export default __webpack_public_path__ + "static/media/9.92dab2b8.jpg";